import { useState } from "react";
import Logout from "../components/Logout";
import NavigationButton from "./NavigationButton";

import { withRouter } from "../utils/withRouter.js";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "./HeadingBanner.scss";

function HeadingBanner(props) {
  const colour = useState("grey");
  let purchased = props.purchased;
  let purchased_2425 = props.purchased_2425;
  let purchased_2526 = props.purchased_2526;
  let purchased_2627 = props.purchased_2627;

  const cloudContent = (
    <div>
      <div className="leftPosition">
        <NavigationButton
          img="/assets/imgs/home_icon.svg"
          alt="home"
          route="/masterdashboard"
          isLoggedIn={props.isLoggedIn}
          teacherid={props.teacherid}
          className="navigation-icon" // Add a class for consistent styling
        />
      </div>
      <div className="centrePosition">
        <NavigationButton
          img="/assets/imgs/avatar.svg"
          alt="profile"
          route="/profile"
          isLoggedIn={props.isLoggedIn}
          teacherid={props.teacherid}
          className="navigation-icon" // Add the same class
        />
      </div>
      <div className="rightPosition">
        <Logout isLoggedIn={props.isLoggedIn} />
      </div>
    </div>
  );

  return (
    <div className="headerContainer">
      <MainBanner
        name={props.name}
        cloud={props.cloud}
        control={cloudContent}
        purchased={purchased}
        purchased_2425={purchased_2425}
        purchased_2526={purchased_2526}
        purchased_2627={purchased_2627}
      />
    </div>
  );
}

function MainBanner(props) {
  let name = props.name;
  let cloud = props.cloud;
  let control = props.control;
  let purchased = props.purchased;
  let purchased_2425 = props.purchased_2425;
  let purchased_2526 = props.purchased_2526;
  let purchased_2627 = props.purchased_2627;

  let purchasedText_2425 =
    "Your school has purchased ALPACA for the 24/25 school year";
  
  let purchasedText_2526 =
    "Your school has purchased ALPACA for the 25/26 school year";

  let purchasedText_2627 =
    "Your school has purchased ALPACA for the 26/27 school year";

  // Determine which purchased text to display (most recent year takes precedence)
  let displayPurchasedText = null;
  if (purchased_2627) {
    displayPurchasedText = purchasedText_2627;
  } else if (purchased_2526) {
    displayPurchasedText = purchasedText_2526;
  } else if (purchased_2425) {
    displayPurchasedText = purchasedText_2425;
  }

  return (
    <Row className="subheader">
      <Col className="d-flex">
        <div className="logo col-2"></div>
        <h2 className="subheading-text col-7">
          {name}
          {displayPurchasedText && (
            <span className="purchased-text"> ({displayPurchasedText})</span>
          )}
        </h2>
        <div className={`${cloud ? "cloud" : "circle"}`}>{control}</div>
      </Col>
    </Row>
  );
}

export default withRouter(HeadingBanner);